<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto animate-fade-in-up">
      
      <div class="text-center mb-16">
        <h1 class="text-4xl md:text-5xl font-extrabold text-base-content mb-4">Get in Touch</h1>
        <p class="text-xl text-base-content/70">Have questions about Aanza? We're here to help.</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
        <!-- Contact Info -->
        <div class="space-y-8">
          <div class="flex items-start gap-4">
            <div class="bg-primary/10 p-3 rounded-xl text-primary">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
            </div>
            <div>
              <h3 class="text-xl font-bold">Email Us</h3>
              <p class="text-base-content/70 mt-1">For general inquiries and support.</p>
              <a href="mailto:info@aanzamenu.com" class="text-primary font-medium hover:underline mt-2 inline-block">info@aanzamenu.com</a>
            </div>
          </div>
          
          <div class="flex items-start gap-4">
            <div class="bg-primary/10 p-3 rounded-xl text-primary">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
            </div>
            <div>
              <h3 class="text-xl font-bold">Call Us</h3>
              <p class="text-base-content/70 mt-1">Mon-Fri from 9am to 6pm.</p>
              <a href="tel:+8801521435356" class="text-primary font-medium hover:underline mt-2 inline-block">+880 1521-435356</a>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="card bg-base-100 shadow-xl">
          <div class="card-body">
            <form class="space-y-4" @submit.prevent>
              <div class="form-control">
                <label class="label"><span class="label-text">Name</span></label>
                <input type="text" placeholder="Your name" class="input input-bordered input-primary w-full" />
              </div>
              <div class="form-control">
                <label class="label"><span class="label-text">Email</span></label>
                <input type="email" placeholder="Your email address" class="input input-bordered input-primary w-full" />
              </div>
              <div class="form-control">
                <label class="label"><span class="label-text">Message</span></label>
                <textarea class="textarea textarea-bordered textarea-primary h-24 w-full" placeholder="How can we help?"></textarea>
              </div>
              <button class="btn btn-primary w-full mt-4 hover:-translate-y-1 transition-transform">Send Message</button>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
